<mat-form-field class="form-field" appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [class.spinner]="!_data">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="filteredCtrl"
        placeholderLabel="Search"
        noEntriesFoundLabel="No entries found"
      ></ngx-mat-select-search>
    </mat-option>
    <mat-option
      class="form-field-option"
      *ngFor="let entry of filteredData | async"
      [value]="entry.id"
    >
      {{ entry.value }}
    </mat-option>
  </mat-select>
  <button
    *ngIf="control.value"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="clear()"
  >
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
